module.exports = __webpack_public_path__ + "media/components/Header/static/logo-wide-2a02dd09282cb55616ee7900bd2d09f6.svg";